<template>
  <div>
    <div class="banner-box" style="position: relative">
      <div class="fix-box">
        <div class="fix-img">
          <div class="flex-center">
            <img
              class="fix-image1"
              src="../../../static/home/102-text.png"
              alt=""
            />
          </div>
          <div class="flex-center">
            <img
              class="fix-image2"
              src="../../../static/home/english.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <el-carousel
        arrow="never"
        height="460px"
        :autoplay="false"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <div class="imgbox">
            <img class="banner-active" :src="$url + item.img" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {
      bannerList: ["/static/home/bianping.png", "/static/home/bianping.png"],
    };
  },
  mounted() {
    this.apiOneBanner();
  },
  methods: {
    apiOneBanner() {
      this.$http.get(`/appapi/banner/list?type=1`).then((res) => {
        if (res.code == 200) {
          this.bannerList = res.rows;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

 <style >
.banner-box {
  position: relative;
  top: -1px;
  left: 0;
  right: 0;
  margin-top: 100px;
}
.fix-box {
  position: absolute;
  width: 100%;
  height: 460px;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fix-img {
}
.fix-img1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fix-img2 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fix-image1 {
  width: 965px;
  height: 184px;
}
.fix-image2 {
  width: 900px;
  height: 60px;
}
.imgbox {
  width: 100%;
  height: 460px;
  object-fit: cover;
}
.banner-active {
  width: 100%;
  height: 460px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/global/banner.vue